(function($){

  $.fn.serializeArrayAll = function () {
    var rCRLF = /\r?\n/g;
    return this.map(function () {
      return this.elements ? jQuery.makeArray(this.elements) : this;
    }).map(function (i, elem) {
      var val = jQuery(this).val();
      if (val == null) {
        return val == null
        //next 2 lines of code look if it is a checkbox and set the value to blank 
        //if it is unchecked
      } else if (this.type == "checkbox" && this.checked == false) {
        return {name: this.name, value: this.checked ? this.value : ''}
        //next lines are kept from default jQuery implementation and 
        //default to all checkboxes = on
      } else {
        return jQuery.isArray(val) ?
                jQuery.map(val, function (val, i) {
                  return {name: elem.name, value: val.replace(rCRLF, "\r\n")};
                }) :
                {name: elem.name, value: val.replace(rCRLF, "\r\n")};
      }
    }).get();
  };

  $(document).ready(function(){

    $('.filter-product-button').click(function(event){

      event.preventDefault();

      $('.sidebar-mobile').slideToggle(200);

    })

    $( document ).on('click', 'li.variable-item', function(event) {

      event.preventDefault();

      value = $(this).data('value');
      select = $( 'select[name="' + $(this).closest('ul').data('attribute_name') + '"]' );

      $(this).addClass('is-active').siblings().removeClass('is-active');

      select.val(value).trigger('change');

    });

    $( document ).on('click', '.reset_variations', function(event) {

      $('li.variable-item').removeClass('is-active');

    });

    $(document).on('focus click', '#customer_details .form-row .input-text, #customer_details .form-row select', function(event) {

      $(this).closest('.form-row').addClass('is-active');

    });

    $(document).on('blur change', '#customer_details .form-row .input-text, #customer_details .form-row select', function(event) {

      if ( !$(this).val() ) {
        $(this).closest('.form-row').removeClass('is-active');
      }

    });

    $('#customer_details .form-row .input-text, #customer_details .form-row select').each( function(index, val) {

      if ( $(this).val() ) {
        $(this).closest('.form-row').addClass('is-active');
      }

    });

    $(document).on('click', '.close-header-cart, .button-close-cart', function(event) {

      $('.header-cart').removeClass('is-open');
      $('body').removeClass('is-blur');

    });

    $(document).on('click', '#place_order', function(event) {

      $('.checkout.woocommerce-checkout').submit();

    });

    $(document).on('added_to_cart', function( event, fragments, cart_hash){

      $('html').addClass('show-sidebar show-sidebar-cart');

      $('.single_add_to_cart_button').removeClass('is-loading');

    });

    // $( ".single_variation_wrap" ).on( "show_variation", function ( event, variation ) {

    //   if ( variation.display_price ) {
    //     $('p.price').hide();
    //   }
    //   $('.mimo-woocommerce-variation-price').html( variation.price_html );

    // } );

    // $( ".variations_form" ).on( "hide_variation", function ( event, variation ) {

    //   $('p.price').show();
    //   $('.mimo-woocommerce-variation-price').empty();

    // } );

    if ( $('body').hasClass('is-add-to-cart') ) {

      $( '.header-cart' ).addClass('is-open');
      $('body').addClass('is-blur');

    }

    $( document ).on('click', '.mimo-checkout_coupon button', function(event) {

      event.preventDefault();

      $( '.checkout_coupon-response' ).empty();

      var $form = $('form.checkout_coupon');

      if ( $form.is( '.processing' ) ) {
        return false;
      }

      // $form.addClass( 'processing' ).block({
      //   message: null,
      //   overlayCSS: {
      //     background: '#fff',
      //     opacity: 0.6
      //   }
      // });

      var data = {
        security:   wc_checkout_params.apply_coupon_nonce,
        coupon_code:  $form.find( 'input[name="coupon_code"]' ).val()
      };

      $.ajax({
        type:   'POST',
        url:    wc_checkout_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'apply_coupon' ),
        data:   data,
        success:  function( code ) {
          $form.removeClass( 'processing' ).unblock();
          if ( code ) {

            $( document.body ).trigger( 'update_checkout', { update_shipping_method: false } );
            setTimeout(function(){
              $('.checkout_coupon-response').prepend( code );
            }, 1000);

          }
        },
        dataType: 'html'
      });

    });

    // $( document ).on('click', 'body:not(.woocommerce-cart) .header-icon li.header-cart > a', function(event) {

    //   event.preventDefault();
    //   $( this ).closest('li').toggleClass('is-open');
    //   $('body').toggleClass('is-blur');

    // });

    $( document ).on('click', '.quantity button', function(event) {

      event.preventDefault();

      $('[name="update_cart"]').prop('disabled', false);

      var input = $(this).closest('.quantity').find( '.input-text.qty' );
      var value = parseInt( input.val() );

      if ( $(this).attr('class') == 'up' ) {
        value = value + 1;
      }else{
        if ( input.val() > 1 ) value = value - 1;
      }

      input.val( value );

      $(this).closest('.product-footer').find('.add_to_cart_button').data('quantity', value)

    });

    $('.quantity .qty').on('keyup blur', function() {

      $(this).closest('.product-footer').find('.add_to_cart_button').data('quantity', $(this).val())

    });

    $(document).on('click', '.single_add_to_cart_button:not(.disabled)', function(event) {
      
      const t = $(this)
      const form = t.closest('form.cart')

      t.addClass('is-loading')

      //quantity = $form.find('input[name=quantity]').val() || 1,
      //product_id = $form.find('input[name=variation_id]').val() || $thisbutton.val(),
      data = form.find('input:not([name="product_id"]), select, button, textarea').serializeArrayAll() || 0

      $.each(data, function (i, item) {
        if (item.name == 'add-to-cart') {
          item.name = 'product_id';
          item.value = form.find('input[name=variation_id]').val() || t.val()
        }
      });

      $(document.body).trigger('adding_to_cart', [t, data])

      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: woocommerce_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart'),
        data: data,
        success : function(data){

          t.removeClass('is-loading')

          if (data.error & data.product_url) {
            window.location = data.product_url
            return;
          }
  
          $(document.body).trigger('added_to_cart', [data.fragments, data.cart_hash, t])
        },
        complete: function(data){},
        error : function( err ){
        }

      });
  
      event.preventDefault();

    });

  });

  $(window).on('load', function() {

  });

})(jQuery);